import React, { ChangeEvent, useState } from 'react';

import FontIconButton from '@atom/components/common/FontIconButton';
import { Button, Modal, TextField } from '@atom/mui';
import { FormatAlignLeftIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';

import classes from '../formInstance.module.css';

const styles = {
  icon: {
    padding: '0px',
    height: '24px',
    width: '24px',
  },
  dialog: {
    bodyStyle: {
      margin: 0,
      padding: 0,
    },
    title: {
      fontSize: fonts.xl,
      padding: '1.125em',
      fontWeight: '500',
    },
    actionsContainerStyle: {
      paddingRight: '1rem',
      paddingBottom: '1rem',
    },
  },
  actionButtons: {
    cancel: { marginRight: '1rem' },
  },
};

interface Props {
  remarks: string;
  isEditable: boolean;
  saveRemarks: (value: string) => void;
  hasRemarks: boolean;
}

const FhwaRemarksModal = ({
  remarks,
  isEditable,
  hasRemarks,
  saveRemarks,
}: Props) => {
  const [remarksCart, setRemarksCart] = useState<string>();
  const [open, setOpen] = useState<boolean>();

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRemarksCart(event.target.value);
  };

  const closeModal = () => {
    setOpen(false);
    setRemarksCart(remarks);
  };

  const openModal = () => {
    setOpen(true);
    setRemarksCart(remarks);
  };

  const confirm = () => {
    saveRemarks(remarksCart);
    closeModal();
  };

  const remarksIconColor = hasRemarks
    ? colors.brand.blue
    : colors.neutral.silver;

  const getFooter = () => {
    return (
      <div style={styles.dialog.actionsContainerStyle}>
        <Button sx={styles.actionButtons.cancel} onClick={closeModal}>
          Cancel
        </Button>
        <Button
          disabled={!isEditable}
          onClick={confirm}
          color="primary"
          variant="contained"
        >
          Save
        </Button>
      </div>
    );
  };

  return (
    <React.Fragment>
      <FontIconButton
        style={styles.icon}
        onClick={openModal}
        color={remarksIconColor}
        icon={FormatAlignLeftIcon}
      />
      <Modal
        title="Notes"
        footer={getFooter()}
        style={styles.dialog.bodyStyle}
        open={open}
      >
        <div className={classes.modalContainer}>
          <TextField
            variant="standard"
            multiline
            value={remarksCart}
            name="remarks"
            onChange={onChange}
            disabled={!isEditable}
          />
        </div>
      </Modal>
    </React.Fragment>
  );
};
export default FhwaRemarksModal;
